import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Comment } from './model/comment';
import { AccountUserService } from '../service/account.service';
import { CategoryGroupIds, TypeGroupIds } from '../modules/shared/constants/category-groupid.constants';

@Injectable()
export class CasesService {
    appUrl = "";
    appOrgUrl = "";
    configUrl ="";
    localAppUrl = "";
    coreUrl = "";
    apiUrlAccount = "";
    apiUrlLogin = "";
    user;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient, private accountUserService: AccountUserService) {
        this.accountUserService.user.subscribe(x => this.user = x);
        this.apiUrlLogin = environment.apiUrlLogin;
        this.localAppUrl = environment.localApiUrl;
        this.appUrl = environment.appUrl;
        this.appOrgUrl = environment.appOrgUrl;
        this.coreUrl = environment.coreUrl;
        this.apiUrlAccount = environment.apiUrlAccount;
        this.configUrl = `${environment.configUrl}Configuration/`
    }

    getLoggedUser(userId) {
        return this.http.get<any>(this.localAppUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    getLoggedUserDetails(userId:number) {
        return this.http.get<any>(environment.appOrgUrl + 'User/' + userId)
    }

    updateUser(user) {
        return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }

    getAllCases(pageSize: number, pageNumber: number, companyID: number, stageId: number, userId:number,  options?, objectNameList?) :Observable<any>{
        let url = `${this.appUrl}Ticket?loginUserId=${userId}&stageId=${stageId}&pageNumber=${pageNumber}&pageSize=${pageSize}${objectNameList}`
        if(options){
            if(options.sort){
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }

            if(options.contactAssociationTypeId){
                url = `${url}&contactAssociationTypeId=${options.contactAssociationTypeId}`;
            }
            if(options.filter && options.filter.field){
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
            if(options.recentFilters){
                url = `${url}&filters=${options.recentFilters}`;
            }
             if(options.channelId){
                url = `${url}&channelId=${options.channelId}`;
            }
        }
        // default sorting
        if(!options || !options.sort){
            url = `${url}&SortBy=createdate&IsAscending=false`;
        }
        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders({
                "organizationId": `${companyID}`,
                "userId": `${userId}`,
            })
        });


    }

    getAllTickets(pageSize: number, pageNumber: number, companyID: number, stageId: number, userId?:number,globalChannelId?:number,  options?, objectNameList?) :Observable<any>{
        let url = `${this.appUrl}Ticket/GetTicketList?stageId=${stageId}&pageNumber=${pageNumber}&pageSize=${pageSize}&globalChannelId=${globalChannelId}`
        if(options){
            if(options.sort){
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if(options.filter && options.filter.field){
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
            if(options.recentFilters){
                url = `${url}&filters=${options.recentFilters}`;
            }
             if(options.channelId){
                url = `${url}&channelId=${options.channelId}`;
            }
        }
        // default sorting
        if(!options || !options.sort){
            url = `${url}&SortBy=createdate&IsAscending=false`;
        }
        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders({
                "organizationId": `${companyID}`,
                "userId": `${userId}`,
            })
        });
    }

    getAllTicketsWithName(channelId, search?) {
        let searchValue = search ? search : "";
        return this.http.get<any>(`${this.appUrl}Ticket/TicketsWithName?channelId=${channelId}&search=${searchValue}`);
    }

    addCase(caseData) : Observable<any> {
        return this.http.post<any>(`${this.appUrl}Ticket`, caseData);
    }

    getCaseById(caseId) {
        return this.http.get<any>(`${this.appUrl}Ticket/${caseId}`);
    }

    updateCase(caseData) {
        return this.http.put<any>(`${this.appUrl}Ticket`, caseData);
    }

    deleteCase(caseId) {
        return this.http.delete<any>(`${this.appUrl}Ticket/${caseId}`);
    }

    checkClearBitData(email) {
        return this.http.get<any>(environment.clearBitAPIURL + email, {
            headers: new HttpHeaders({
                "Authorization": environment.clearBitAPIKey
            })
        })
            .toPromise()
            .then(res => res)
    }


    getAllContactAssociation(): Observable<any>{
        return this.http.get<any>( `${this.appUrl}Type?groupId=${TypeGroupIds.ContactAssociationTicketAPI}`);
    }

    getAllStages(organizationId, channelId, globalChannelId: number, options, includeCases?: boolean, pageNumber?) {
        let url = `${this.appUrl}Ticket/count?organizationId=${organizationId}&groupId=${TypeGroupIds.StageGroupIDTicketAPI}&typeId=0&channelId=${channelId}&globalChannelId=${globalChannelId}`;
      

        if(options && options.recentFilters){
            url = `${url}&filters=${options.recentFilters}`;
        }

        if(includeCases){
            url = `${url}&includeCases=${includeCases}&PageSize=15&PageNumber=${pageNumber}&SortBy=CreatedDate&IsAscending=false`;
        }
        // if(includeCases){
        //     url = `${url}&includeCases=${includeCases}`;
        // }

        return this.http.get<any>(url)
    }

    updateCaseStage(caseStage) {
        return this.http.put<any>( `${this.appUrl}Ticket/Stage`,caseStage)
    }

    updateTicketStage(caseStage) {
        return this.http.put<any>( `${this.appUrl}Ticket/UpdateStage`,caseStage)
    }

    getAllContactSource(companyID: number) : Observable<any>{
        return this.http.get<any>(this.coreUrl + 'Source/' + "?organizationId=" + companyID )
    }

    getAllCategory() {
        return this.http.get<any>(`${this.appUrl}Category?groupId=${CategoryGroupIds.CaseCategoryTicketAPI}`)
    }

    getAllPirority(organizationId) {
        return this.http.get<any>(`${this.coreUrl}Priority`, {
            headers: new HttpHeaders({
                "organizationId": organizationId
            })
        });
    }

    getActivityLogs(ticketId: number): Observable<Comment[]>{
        return this.http.get<any>(`${this.appUrl}Ticket/${ticketId}/ActivityLog`);
    }

    deleteCaseComment(commentId): Observable<any>{
        return this.http.delete<any>( `${this.coreUrl}ObjectStageAudit/${commentId}`)
    }

    getUserGroups(organizationId:number): Observable<any[]>{
        return this.http.get<any>( `${this.appOrgUrl}UserGroup/GetMyUserGroups?groupId=0`, {
        // return this.http.get<any>( `${environment.appOrgUrl}UserGroup?groupId=0`, {
            headers: new HttpHeaders({
                "organizationId": `${organizationId}`
            })
        });
    }

    assignUser(tickedId: number, data){
        return this.http.post<any>( `${this.appUrl}Ticket/AssignUser/${tickedId}`,  data)
            .toPromise()
            .then(res => res);
    }

    getLeadDashboardData() {
        return this.http.get<any>(this.localAppUrl + 'leadDashboard')
            .toPromise()
            .then(res => res);
    }

    getAllTypes(){
        return this.http.get<any>(`${environment.appOrgUrl}Type`)
    }

    getCaseConfigurations(){
        return this.http.get<any>( `${this.configUrl}ConfigurationsByModuleName?name=case`)
    }

    getAllCustomFieldTypes(id) {
        return this.http.get<any>(environment.configUrl + "Configuration/FormControls?objectId="+id)
          .toPromise()
          .then(res => res);
    }

    getAllCustomFields(id) {
        return this.http.get<any>(environment.configUrl + 'Configuration/CustomAttributes?objectId=' + id)
    }

    getCaseColumnsSetings(templateId, objectId) {
        return this.http.get<any>(`${environment.configUrl}Configuration/ColumnSetting/${templateId}?objectId=${objectId}`)
    }

    getResolutionDays(resolutionDays: number){
        return this.http.get(`${environment.appUrl}Category/GetResolutionDayWiseDate?resolutionDay=${resolutionDays}`,
        {
            responseType: 'text'
        });
        // .toPromise()
        // .then(res => res.text());
    }

}
